import axios from 'axios';

export const takeListPromotion = (branchID, token) => {
    let newURL = "/promotion/" + branchID + "/take_list_promotion";
    return axios.get(`${newURL}`, {
        headers: { Authorization: token }
    });
}

export const addNewPromotion = (branchID, token) => {
    let newURL = "/promotion/" + branchID + "/new_promotion";
    return axios.post(`${newURL}`,{
        headers: { Authorization: token }
    });
}

export const editPromotion = (branchID, data, token) => {
    let newURL = "/promotion/" + branchID + "/edit_promotion";
    return axios.patch(`${newURL}`, data,{
        headers: { Authorization: token }
    });
}